import { hasRole, ROLES } from "./permissions";
import { menuItemsByPrivileges } from "./menus";

const DASHBOARD = "/dashboard";

const getFirstRoute = (menu) => {
  for (const item of menu) {
    if (!item) continue;

    if (item.path) return item.path;

    if (item.child?.length) {
      const route = getFirstRoute(item.child);
      if (route) return route;
    }
  }
  return null;
};

// Landing page for the connected user: the dashboard for admins/suppliers,
// otherwise the first screen of their menu (same page opened after sign-in).
export const getDefaultRoute = () => {
  if (hasRole(ROLES.ADMIN) || hasRole(ROLES.SUPPLIER)) return DASHBOARD;
  return getFirstRoute(menuItemsByPrivileges()) || DASHBOARD;
};
